<template>
  <div class="main">

    <div class="box">
      <el-container>
        <el-main>
          <newlist></newlist>
          <business></business>

          <div class="notice">
            <div class="proclamations">
              <proclamation></proclamation>
            </div>
            <div class="standard">
              <standard></standard>
            </div>
          </div>

          <div>
            <companion></companion>
          </div>
        </el-main>

        <!-- <el-aside width="15%">
          <div
            class="nav" :class="{ active: item.categoryId == $store.state.categoryAppid}"
            v-for="item in $store.state.categoryList"
            :key="item.categoryId"
            @click="chooseCategory(item.categoryId)"
          >
          <img class="icon" :src="$store.state.baseUrl+'/images/'+item.categorySmallimg">
          {{item.categoryTitle}}
          </div>
        </el-aside> -->
      </el-container>
    </div>
  </div>
</template>

<script>
import newlist from '@/components/Layout/NewList'
import business from '@/components/Layout/Business'
import proclamation from '@/components/Layout/Proclamation'
import standard from '@/components/Layout/Standard'
import companion from '@/components/Layout/Companion'


export default {
  components: {
    business,
    newlist,
    proclamation,
    standard,
    companion
  },
  created() {
    if(this.$route.params.id && this.$route.params.id !== undefined) {
      // console.log(1)
      this.$store.commit('setCategory', {id: this.$route.params.id})
    }
  },
  methods: {
    chooseCategory(id) {
      this.$store.commit('setCategory', {id: id})
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  background-color: #e9eef3;
}
.box {
  margin: 0 auto;
  .el-main {
    color: #333;
    .notice {
      display: flex;
      justify-content: space-between;
      .proclamations {
        width: 45%;
      }
      .standard {
        width: 45%;
      }
    }
  }
  .el-aside {
    color: #333;
    .nav {
      margin: 20px;
      border: 1px solid #018FD7;
      cursor: pointer;
      padding: 5px;
      font-size: 12px;
      &:hover {
        color: #ffd04b;
      }
    }
    .icon {
      width: 40%;
      display: block;
      margin: 0 auto;
    }
  }
}
.active {
  color: #018FD7;
}
</style>
